import alertifyjs from 'alertifyjs';

require('alertifyjs/build/css/alertify.css');

const CONFIRM_TITLE = 'Unsaved Changes';
const CONFIRM_MESSAGE = 'Continue without saving? Your changes will be lost.';

// alertifyjs behaves a bit weirdly with undefined callbacks. set default noops.
const NOOP = () => {};

const showReminder = (title = CONFIRM_TITLE, message = CONFIRM_MESSAGE,
    onOkCallback = NOOP, onCancelCallback = NOOP) => {
  alertifyjs
  .confirm(title, message, onOkCallback, onCancelCallback)
  .set('movable', false)
  .set('transition', 'fade');
};

const showUnsavedChangesReminder = (onOkCallback, onCancelCallback) =>
  showReminder(CONFIRM_TITLE, CONFIRM_MESSAGE, onOkCallback, onCancelCallback);

export const ConfirmationPrompt = { showReminder, showUnsavedChangesReminder };

export default ConfirmationPrompt;



// WEBPACK FOOTER //
// ./domain/ConfirmationPrompt/index.js